import DataGrid, { Column, Scrolling } from 'devextreme-react/cjs/data-grid';
import React from 'react'
import { Modal } from 'react-bootstrap';

interface SalesEntryProductProp {
    productData: any;
    onClose: () => void;
}

const SalesEntryProduct: React.FC<SalesEntryProductProp> = ({ productData, onClose }) => {
    return (
        <>
            <Modal size="xl" show={true} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DataGrid
                        dataSource={productData}
                        keyExpr="id"
                        showBorders={true}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                    >
                        <Scrolling
                            mode='standard'
                            useNative={true}
                            scrollByContent={true}
                            scrollByThumb={true}
                        />
                        <Column dataField="invoiceNo" caption="Invoice No" />
                        <Column dataField="soDate" caption="SO Date" dataType="date" format="dd/MM/yyyy" />
                        <Column dataField="diaWt" caption="Dia Wt" format="#,##0.000" />
                        <Column dataField="netWt" caption="Net Wt" format="#,##0.000" />
                        <Column dataField="diaQty" caption="Dia Qty" />
                        <Column dataField="grossWt" caption="Gross Wt" format="#,##0.000" />
                        <Column dataField="category" caption="Category" />
                        <Column dataField="style" caption="Style" />
                        <Column dataField="karat" caption="Karat" />
                        <Column dataField="igiNo" caption="IGI No" />
                        <Column dataField="huid" caption="HUID" />
                        <Column dataField="dpPrice" caption="DP Price" format="#,##0.00" />
                        <Column dataField="colorStonePrice" caption="Color Stone Price" format="#,##0.00" />
                        <Column dataField="diamondMrp" caption="Diamond Price" format="#,##0.00" />
                        <Column dataField="selingPrice" caption="Selling Price" format="#,##0.00" />
                        <Column dataField="isSRP" caption="SRP" />
                        <Column dataField="complexityName" caption="Complexity" />
                        <Column dataField="complexityPercentage" caption="Complexity %" format="#0.##" />
                        <Column dataField="materialType" caption="Material Type" />
                    </DataGrid>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SalesEntryProduct
